// frontend/features/mpc-common/src/features/Bidding/SupplierQuoteDrawer/QuoteDetailField.tsx
import React, { useState } from 'react';
import { Space } from '@bedrock/components';
import { useControllableValue } from 'ahooks';
import BiddingSupplierQuoteButton from './index';

/** value 形态: 报价明细 tabs 数据数组 */
type QuoteDetailValue = Record<string, any>[];

interface Props {
  detail: any;
  view?: boolean; // true=父表单只读态
  value?: QuoteDetailValue;
  onChange?: (value: QuoteDetailValue) => void;
}

const QuoteDetailField: React.FC<Props> = React.forwardRef((props, ref) => {
  const { view, detail } = props;
  const [value, setValue] = useControllableValue<QuoteDetailValue>(props, {
    defaultValue: [],
  });

  const [hasSubmit, setHasSubmit] = useState(false);

  const handleCommit = (tabs: Record<string, any>[]) => {
    setHasSubmit(true);
    setValue(tabs);
  };

  const hasValue = !!value?.length;

  if (view && !hasValue) {
    return <span className="text-color-3">--</span>;
  }

  return (
    <Space direction="vertical" size={0} className="w-full">
      {/* 编辑态:始终显示"填写明细"按钮 */}
      <BiddingSupplierQuoteButton
        detail={detail}
        viewMode={view ? 'view' : 'edit'}
        buttonText={hasSubmit || view ? '查看报价明细' : '填写明细'}
        initialTabs={value}
        onCommit={handleCommit}
      />
    </Space>
  );
});

export default QuoteDetailField;
